import React, { useEffect, useState } from "react";
import AssignedToModal from "../../../../components/modals/SeriveModals/AddServicesModals/AssignedToModal";

const ServiceManagement = React.memo(({ ServiceManagementdata, setServiceManagaementData }) => {

    const [recommendedfor, setRecommendedFor] = useState('')

    const addedBy = 'Admin'
    const lastAddedBy = 'Admin'
    const currentDate = new Date().toISOString().split('T')[0];
    const currentTime = new Date().toLocaleTimeString('en-GB'); // 24-hour format

    // Handle input change and update assignment state
    const handleDataChange = (e) => {
        const { name, value } = e.target;
        setServiceManagaementData({ ...ServiceManagementdata, [name]: value });
    };

    // Handle assigned_to data from the modal
    const handleAssignedTo = (onAssign) => {
        console.log('assign', onAssign);

        setServiceManagaementData({ ...ServiceManagementdata, Product_assign: onAssign });
    };

    const handleRecommendefor = (e) => {
        setRecommendedFor(e.target.value);
        setServiceManagaementData({ ...ServiceManagementdata, p_recommended_for_id: Number(e.target.selectedOptions[0].id) });
    };

    useEffect(() => {
        setServiceManagaementData({ ...ServiceManagementdata, p_add_by: addedBy, p_last_modified_by: lastAddedBy })
    }, [])

    return (
        <div className="grid grid-cols-2 gap-6 mx-10">
            {/* Other Fields */}
            <div className="flex flex-col">
                <label htmlFor="addedBy" className="font-semibold text-[#667085]">
                    Service Added By
                </label>
                <input
                    id="addedBy"
                    name="p_add_by"
                    value={ServiceManagementdata.p_add_by || addedBy}
                    // onChange={handleDataChange}
                    disabled
                    type="text"
                    className="mt-2 p-2 border border-gray-300 rounded-md outline-sky-300"
                />
            </div>
            <div className="flex flex-col">
                <label htmlFor="addedDate" className="font-semibold text-[#667085]">
                    Service Added Date
                </label>
                <input
                    id="addedDate"
                    name="p_add_date"
                    value={ServiceManagementdata.p_add_date || currentDate}
                    // onChange={handleDataChange}
                    type="date"
                    disabled
                    className="mt-2 p-2 border border-gray-300 rounded-md outline-sky-300"
                />
            </div>

            {/* Required Fields */}
            <div className="flex flex-col">
                <label htmlFor="addTime" className="font-semibold text-[#667085]">
                    Service Added Time <span className="text-red-500">*</span>
                </label>
                <input
                    id="addTime"
                    name="p_add_time"
                    value={ServiceManagementdata.p_add_time || currentTime}
                    // onChange={handleDataChange}
                    type="text"
                    disabled
                    required
                    className="mt-2 p-2 border border-gray-300 rounded-md outline-sky-300"
                />
            </div>
            <div className="flex flex-col">
                <label htmlFor="lastModifiedBy" className="font-semibold text-[#667085]">
                    Service Last Modified By <span className="text-red-500">*</span>
                </label>
                <input
                    id="lastModifiedBy"
                    name="p_last_modified_by"
                    value={ServiceManagementdata.p_last_modified_by || lastAddedBy}
                    // onChange={handleDataChange}
                    disabled
                    type="text"
                    className="mt-2 p-2 border border-gray-300 rounded-md outline-sky-300"
                />
            </div>
            <div className="flex flex-col">
                <label htmlFor="lastModifiedDate" className="font-semibold text-[#667085]">
                    Service Last Modified Date <span className="text-red-500">*</span>
                </label>
                <input
                    id="lastModifiedDate"
                    name="p_last_modified_date"
                    value={ServiceManagementdata.p_last_modified_date || currentDate}
                    // onChange={handleDataChange}
                    type="date"
                    disabled
                    required
                    className="mt-2 p-2 border border-gray-300 rounded-md outline-sky-300"
                />
            </div>  
            <div className="flex flex-col">
                <label htmlFor="lastModifiedTime" className="font-semibold text-[#667085]">
                    Service Last Modified Time <span className="text-red-500">*</span>
                </label>
                <input
                    id="lastModifiedTime"
                    name="p_last_modified_time"
                    value={ServiceManagementdata.p_last_modified_time || currentTime}
                    // onChange={handleDataChange}
                    type="time"
                    disabled
                    required
                    className="mt-2 p-2 border border-gray-300 rounded-md outline-sky-300"
                />
            </div>
            <div className="flex flex-col">
                <label htmlFor="productOwner" className="font-semibold text-[#667085]">
                    Service Owner <span className="text-red-500">*</span>
                </label>
                <input
                    id="productOwner"
                    name="p_owner"
                    value={ServiceManagementdata.p_owner || ''}
                    onChange={handleDataChange}
                    type="text"
                    placeholder="Enter Product Owner name..."
                    required
                    className="mt-2 p-2 border border-gray-300 rounded-md outline-sky-300"
                />
            </div>
            <div className="flex flex-col">
                <label htmlFor="nextStep" className="font-semibold text-[#667085]">
                    Next Step <span className="text-red-500">*</span>
                </label>
                <input
                    id="nextStep"
                    name="next_step"
                    value={ServiceManagementdata.next_step || ''}
                    onChange={handleDataChange}
                    type="text"
                    placeholder="Enter Next Step"
                    required
                    className="mt-2 p-2 border border-gray-300 rounded-md outline-sky-300"
                />
            </div>
            <div className="flex flex-col">
                <label htmlFor="productRecomFor" className="font-semibold text-[#667085]">
                    Service Recommended For <span className="text-red-500">*</span>
                </label>
                <select
                    id="productRecomFor"
                    name="p_recommended_for"
                    value={recommendedfor || ServiceManagementdata.p_recommended_for}
                    onChange={(e) => handleRecommendefor(e)}
                    required
                    className="mt-2 p-2 border border-gray-300 rounded-md outline-sky-300"
                >
                    <option value="">Select an option</option>
                    <option id={1} value="Admin">Admin</option>
                    <option id={2} value="Sub Admin">Sub Admin</option>
                    <option id={3} value="Team Leader">Team Leader</option>
                </select>0
            </div>

            {/* Assigned To Modal */}
            <AssignedToModal onAssign={handleAssignedTo} AssignedData={ServiceManagementdata.product_assign} />

            <div className="flex flex-col">
                <label htmlFor="tags" className="font-semibold text-[#667085]">
                    Tags <span className="text-red-500">*</span>
                </label>
                <input
                    id="tags"
                    name="tag"
                    value={ServiceManagementdata.tag}
                    onChange={handleDataChange}
                    type="text"
                    placeholder="Enter Tags"
                    required
                    className="mt-2 p-2 border border-gray-300 rounded-md outline-sky-300"
                />
            </div>
        </div>
    );
});

export default ServiceManagement;